<div class="container">
  <div class="row back-navigation-btn">
    <div
      appNavigateBack
      class="text-primary cursor-pointer d-inline-flex align-items-center py-2 px-1"
      (click)="navigateToCreateExtrasPage()"
    >
      <i class="mdi mdi-24px mdi-chevron-left"></i>
      <strong>{{ 'GENERAL.BACK_BTN' | translate }}</strong>
    </div>
  </div>
  <stepper-bar [inputSteps]="extrasSteps" [currentStep]="2"></stepper-bar>

  <p class="overview-page-title">{{ 'OVERVIEW_EXTRAS.TITLE' | translate }}</p>
  <app-passenger-details-overview [flightDetails]="flightDetails" [culture]="culture"> </app-passenger-details-overview>

  <app-passengers-total [flightDetails]="flightDetails" [culture]="culture"> </app-passengers-total>

  <div class="row py-3 navigation-buttons-container">
    <div class="col text-left back-navigation-btn">
      <div appNavigateBack class="text-primary cursor-pointer d-inline-flex align-items-center py-2" (click)="navigateToCreateExtrasPage()">
        <i class="mdi mdi-24px mdi-chevron-left"></i>
        <strong>{{ 'GENERAL.BACK_BTN' | translate }}</strong>
      </div>
    </div>
    <div class="col text-right button-overview">
      <app-navigate-next-btn
        [handleOnClick]="true"
        [buttonClass]="'btn-overview'"
        [showIcon]="false"
        [isConfirm]="true"
        (onClick)="openFullscreenLoader()"
      >
      </app-navigate-next-btn>
    </div>
  </div>
</div>
